import { Array, Boolean, Number, Record, Static, String } from 'runtypes'
import { DateString } from 'src/shared/contract/date'

export const GroupItem = Record({
    groupId: Number,
    groupTitle: String
})

export const GoodGroupItem = Record({
    clsGroupID: Number,
    isDefault: Boolean,
    groupUrl: String
})

/**
 * Причины недоставки
 */
export const DeliveryReason = Record({
    deliveryReasonID: Number,
    warningText: String
})

/**
 * Статус доставки
 */
export const DeliveryStatus = Record({
    isAvailableForDelivery: Boolean,
    warningText: String.nullable(),
    reasons: Array(DeliveryReason)
})

export const GoodSortOrderService = Record({
    sortOrder1: Number,
    sortOrder2: Number,
    sortOrder3: Number
})

export const WebData = Record({
    webId: Number,
    goodId: Number,
    drugTitle: String,
    outFormTitle: String,
    makerTitle: String,
    isStrictlyByPrescription: Boolean,
    hasImage: Boolean,
    url: String,
    mnnRusTitle: String,
    brandTitle: String.nullable(),
    brandId: Number.nullable(),
    goodGroups: Array(GoodGroupItem)
})

export const GoodPrice = Record({
    normal: Number.nullable(),
    discount: Number.nullable(),
    promo: Number.nullable(),
    withoutPromo: Number.nullable(),
    aptEtaDateTime: DateString.nullable(),
    isDemand: Boolean.nullable()
})

export const GoodFilter = Record({
    siteFilterID: Number,
    filterValue: String
})

export const CatalogGoodBase = Record({
    webData: WebData,
    /**
     * Количество аналогов
     */
    analoguesQty: Number,
    /**
     * Количеств форм выпуска
     */
    anotherOutFormsQty: Number,
    /**
     * Оригинальный препарат
     */
    isOriginalGood: Boolean,
    /**
     * количество аптек в которых есть данный товар
     */
    availableStocksCount: Number,
    /**
     * Хранение в холоде
     */
    isCold: Boolean,
    /**
     * Статус доставки
     */
    deliveryStatus: DeliveryStatus.nullable(),
    /**
     * Приустсвие гудса
     */
    isAvailable: Boolean,
    /**
     * Доступно для самовывоза
     */
    isAvailableOnStock: Boolean,
    /**
     * Строго рецептуный
     */
    isStrictlyByPrescription: Boolean,
    /**
     * Может ли быть куплен и доставлен по рецепту с ЕМИАС
     */
    isAvailableDeliveryByErecipe: Boolean.nullable(),
    /**
     * Может ли быть забронирован с рецептом ЕМИАС
     */
    isAvailablePickupByErecipe: Boolean.nullable(),
    /**
     * Дата поставки
     */
    aptEtaDateTime: DateString.nullable(),
    /**
     * Заказная позиция
     */
    isDemand: Boolean.nullable(),
    /**
     * Минимальная стоимость
     */
    minPrice: GoodPrice.nullable(),
    /**
     * Стоимость для самовывоза
     */
    stockPrice: GoodPrice.nullable(),
    /**
     * Стоимость для доставки
     */
    deliveryPrice: GoodPrice.nullable(),
    /**
     * Избранное (не используется)
     */
    isFavourite: Boolean,
    /**
     * Ключи для сортировки
     */
    sortOrders: GoodSortOrderService,
    /**
     * Фильтр гудса
     */
    filters: Array(GoodFilter).nullable()
})

export type ICatalogGoodBase = Static<typeof CatalogGoodBase>
export type IGroupItem = Static<typeof GroupItem>
export type IGoodFilter = Static<typeof GoodFilter>
export type IGoodPrice = Static<typeof GoodPrice>
export type IDeliveryStatus = Static<typeof DeliveryStatus>
export type IWebData = Static<typeof WebData>
export type IGoodGroupItem = Static<typeof GoodGroupItem>

export const FullCatalog = Record({
    groups: Array(GroupItem),
    goods: Array(CatalogGoodBase)
})

export type IFullCatalog = Static<typeof FullCatalog>
